import React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography, Switch } from 'components/base';

const SwitchPanel = props => {
  return (
    <Card className="mx-auto mb-2 mb-sm-5 mw-480">
      <Card.Body className="card-body-inline">
        <div>
          <Typography.H6>{props.title}</Typography.H6>
          <Typography.P className="mt-0 mb-0 small">{props.description}</Typography.P>
        </div>
        <Switch switchId={props.title} checked={props.checked} onChange={props.onChange} />
      </Card.Body>
    </Card>
  );
};

SwitchPanel.propTypes = {
  checked: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  onChange: PropTypes.func,
};

export default SwitchPanel;
